import { useMemo } from "react";
import PropTypes from 'prop-types';
import {CDataTable, CCard, CCardBody, CCardHeader} from "@coreui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClipboard} from "@fortawesome/pro-light-svg-icons";
import { useTranslation } from "react-i18next";
import noop from "../../utils/noop";
import {ActionToolbar } from "../Toolbars/ActionToolbar";
import StatusCell from "../StatusCell";
import {useColumnFilter} from "../../hooks/useColumnFilter";
import {tableFilterObject} from "../../common/tableFilterObject";
import ActionsCell from "../ActionsCell";

export const ProductionOrderList = ({records, onAddClick, onEditClick, onDeleteClick, onHistoryClick,  onImportClick, loading, exportHref }) => {
    
    const {t} = useTranslation(["ProductionOrderList", "Common"]);

    const columnFilter = useColumnFilter();
    
    const fields = useMemo(() => ([
            { key: "id", label:t("Common:id") },
            { key: "is_active", label: t("Common:activeColName") },         
            { key: "status", label:t("ProductionOrderList:status"),  _classes: "text-nowrap" },
            { key: "start_date", label:t("ProductionOrderList:startDate"),  _classes: "text-nowrap" },
            { key: "quantity", label:t("ProductionOrderList:quantity"),  _classes: "text-nowrap" },
            { key: "load_level", label:t("ProductionOrderList:loadLevel"),  _classes: "text-nowrap" },
            { key: "wo_order", label:t("ProductionOrderList:woOrder"),  _classes: "text-nowrap" },
            { key: "wo_status", label:t("ProductionOrderList:woStatus"),  _classes: "text-nowrap" },
            { key: "_actions", label: t("Common:actions"), sorter: false, filter: false },
        ]),[t]);
    
    return (         
        <CCard>
            <CCardHeader>
                <div className="d-flex flex-row">
                    <h2 className="mr-2 d-flex flex-row align-items-center"><FontAwesomeIcon icon={faClipboard} className="mr-2"/>{t("ProductionOrderList:productionOrders")}</h2>
                    <div className="ml-auto d-flex">
                        <ActionToolbar className="ml-auto" addButton={false} onAddClick={onAddClick} onImportClick={onImportClick} exportHref={exportHref} />
                    </div>
                </div>
            </CCardHeader>
            <CCardBody>
                <CDataTable
                    size="md"
                    tableFilter={tableFilterObject(t)}
                    cleaner
                    itemsPerPageSelect
                    itemsPerPage={10}
                    columnFilter={columnFilter}
                    footer
                    sorter
                    striped
                    hover
                    responsive
                    pagination
                    noItemsViewSlot={<div>{t("Common:noRecordsFound")}</div>}
                    items={records} fields={fields}
                    loading={loading}
                    scopedSlots={{
                        is_active: item => <StatusCell active={item.is_active} />,
                        _group_key: item => <td>{item.rccp}{item.gl_cat}</td>,
                        _actions: item => <ActionsCell onEditClick={() => onEditClick(item)} onDeleteClick={() => onDeleteClick(item)} onHistoryClick={() => onHistoryClick(item)}/>
                        
                    }}
                />
            </CCardBody>
        </CCard>
        
    );
};

ProductionOrderList.propTypes = {
    records: PropTypes.array,
    loading: PropTypes.bool,
    exportHref: PropTypes.string,
    onAddClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onHistoryClick: PropTypes.func,
    onImportClick: PropTypes.func,
    onExportClick: PropTypes.func
};

ProductionOrderList.defaultProps = {
    records: [],
    loading: false,
    exportHref: "",
    onAddClick: noop,
    onEditClick: noop,
    onDeleteClick: noop,
    onHistoryClick: noop,
    onImportClick: noop,
    onExportClick: noop,
};

export default ProductionOrderList;